import './page-config.js';

if (window.CarbuyPageConfig) {
  window.CarbuyPageConfig.hydrateLegacyGlobals(true);
}
